import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ListAltIcon from "@mui/icons-material/ListAlt";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import ScienceIcon from "@mui/icons-material/Science";
import LocalDrinkIcon from "@mui/icons-material/LocalDrink";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RefreshIcon from "@mui/icons-material/Refresh";

const outlinedBtnSx = {
  borderRadius: 2,
  fontWeight: 600,
  width: "100%",
  textTransform: "none",
};

/**
 * Quick navigation for herd-related tasks. One primary action; other actions use neutral outlined primary styling.
 * @param {{ onRefresh: () => void, showRefresh: boolean, buttonSize?: "small" | "medium" }} props
 */
export default function HerdQuickActions({
  onRefresh,
  showRefresh = true,
  buttonSize = "medium",
}) {
  const navigate = useNavigate();

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={1}>
        {showRefresh && (
          <Grid item xs={12}>
            <Tooltip title="Refresh">
              <span>
                <IconButton
                  onClick={onRefresh}
                  aria-label="Refresh herd summary"
                  size={buttonSize === "small" ? "small" : "medium"}
                  sx={{
                    bgcolor: "background.paper",
                    border: (t) => `1px solid ${t.palette.divider}`,
                  }}
                >
                  <RefreshIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Grid>
        )}
        <Grid item xs={12} sm={6} md={4}>
          <Button
            variant="contained"
            color="primary"
            size={buttonSize}
            startIcon={<AddIcon />}
            onClick={() => navigate("/animal/create_animal")}
            sx={{ ...outlinedBtnSx, fontWeight: 700 }}
          >
            Add animal
          </Button>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Button
            variant="outlined"
            color="primary"
            size={buttonSize}
            startIcon={<ListAltIcon />}
            onClick={() => navigate("/animals")}
            sx={outlinedBtnSx}
          >
            View all animals
          </Button>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Button
            variant="outlined"
            color="primary"
            size={buttonSize}
            startIcon={<LocalDrinkIcon />}
            onClick={() => navigate("/milking")}
            sx={outlinedBtnSx}
          >
            Milking
          </Button>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Button
            variant="outlined"
            color="primary"
            size={buttonSize}
            startIcon={<LocalHospitalIcon />}
            onClick={() => navigate("/treatments")}
            sx={outlinedBtnSx}
          >
            Treatments
          </Button>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Button
            variant="outlined"
            color="primary"
            size={buttonSize}
            startIcon={<AddIcon />}
            onClick={() => navigate("/treatment/create_treatment")}
            sx={outlinedBtnSx}
          >
            Log treatment
          </Button>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Button
            variant="outlined"
            color="primary"
            size={buttonSize}
            startIcon={<ScienceIcon />}
            onClick={() => navigate("/medicines")}
            sx={outlinedBtnSx}
          >
            Medicine stock
          </Button>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Button
            variant="outlined"
            color="primary"
            size={buttonSize}
            startIcon={<ReceiptLongIcon />}
            onClick={() => navigate("/stock-taking")}
            sx={outlinedBtnSx}
          >
            Stock taking
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
